<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'forwarderReviews'">
  <p-breadcrumb class="max-w-full" [model]="breadcrumbItems" [home]="breadcrumbHomeItem"></p-breadcrumb>
  <div style="margin-top: 30px;">
      <p-card *ngIf="review">
        <ng-template pTemplate="header">
          <div class="flex justify-content-between flex-wrap align-items-center" style="padding: 15px;">
            <h2>{{ 'ForwarderPage.ForwarderUserOriginReview.Title' | translate }}</h2>
            <p-button label="{{ 'ForwarderPage.ForwarderUserOriginReview.SendNotification' | translate }}" [badge]="messagePending" badgeClass="p-badge-danger" (onClick)="openMessageDialog()"></p-button>
          </div>
        </ng-template>
        <div style="margin-top: 0;">
          <p-fieldset legend="{{ 'ForwarderPage.ForwarderUserOriginReview.LegendText' | translate }}" [toggleable]="true" [collapsed]="true">
            <div class="grid">
              <div class="col-3">{{ 'ForwarderPage.ForwarderUserOriginReview.ImportOrderLabel' | translate }}:</div>
              <div class="col-3"><span style="font-weight: bolder;">{{ review.importOrderSequence }}</span></div>
              <div class="col-3">{{ 'ForwarderPage.ForwarderUserOriginReview.ImportOrderDetailLabel' | translate }}:</div>
              <div class="col-3"><span style="font-weight: bolder;">{{ review.importOrderDetailSequence }}</span></div>

              <div class="col-3">{{ 'ForwarderPage.ForwarderUserOriginReview.SpeciesVarietyLabel' | translate }}:</div>
              <div class="col-3">
                <span style="font-weight: bolder;">
                  {{ review | speciesName }} - {{ review.varietyName }}
                </span>
              </div>
              <div class="col-3">{{ 'ForwarderPage.ForwarderUserOriginReview.ColdStorageLabel' | translate }}:</div>
              <div class="col-3">
                <span style="font-weight: bolder;">
                  {{ review.fridgeStorageName }} {{ review.fridgeStorageCity }}, {{ review.fridgeStorageCountryName }}
                </span>
              </div>

              <div class="col-3">{{ 'ForwarderPage.ForwarderUserOriginReview.OriginPortLabel' | translate }}:</div>
              <div class="col-3">
                <span style="font-weight: bolder;">
                  {{ review.portFromName }}
                </span>
              </div>
              <div class="col-3">{{ 'ForwarderPage.ForwarderUserOriginReview.DestinationPortLabel' | translate }}:</div>
              <div class="col-3">
                <span style="font-weight: bolder;">
                  {{ review.portToName }}
                </span>
              </div>
            </div>
          </p-fieldset>
        </div>

        <div class="grid" style="margin-top: 20px;">
          <div class="col-6" >
            <div>
              <p-card header="{{ 'ForwarderPage.Importer.Title' | translate }}">
                <div class="grid">
                  <div class="col-6">{{ 'ForwarderPage.Importer.CompanyName' | translate }}:</div>
                  <div class="col-6">{{review.importer?.contactName}}</div>
                  <div class="col-6">{{ 'ForwarderPage.Importer.ContactName' | translate }}:</div>
                  <div class="col-6">{{review.importer?.contactName}}</div>
                  <div class="col-6">{{ 'ForwarderPage.Importer.ContactAddress' | translate }}:</div>
                  <div class="col-6">{{review.importer?.contactAddress}}</div>
                  <div class="col-6">{{ 'ForwarderPage.Importer.ContactEmail' | translate }}:</div>
                  <div class="col-6">{{review.importer?.contactEmail}}</div>
                  <div class="col-6">{{ 'ForwarderPage.Importer.ContactCountry' | translate }}:</div>
                  <div class="col-6">{{review.importer?.contactCountry | countryDescription}}</div>
                </div>
              </p-card>
            </div>
          </div>
          <div class="col-6" >
            <div>
              <p-card header="{{ 'ForwarderPage.Exporter.Title' | translate }}">
                <div class="grid">
                  <div class="col-6">{{ 'ForwarderPage.Exporter.CompanyName' | translate }}:</div>
                  <div class="col-6">{{review.exporter?.companyName}}</div>
                  <div class="col-6">{{ 'ForwarderPage.Exporter.ContactName' | translate }}:</div>
                  <div class="col-6">{{review.exporter?.contactName}}</div>
                  <div class="col-6">{{ 'ForwarderPage.Exporter.ContactAddress' | translate }}:</div>
                  <div class="col-6">{{review.exporter?.contactAddress}}</div>
                  <div class="col-6">{{ 'ForwarderPage.Exporter.ContactEmail' | translate }}:</div>
                  <div class="col-6">{{review.exporter?.contactEmail}}</div>
                  <div class="col-6">{{ 'ForwarderPage.Exporter.ContactCountry' | translate }}:</div>
                  <div class="col-6">{{review.exporter?.contactCountry | countryDescription}}</div>
                </div>
              </p-card>
            </div>
          </div>
        </div>

        <div style="margin-top: 50px;">
            <h3>{{ 'ForwarderPage.ForwarderUserOriginReview.TitleDocuments' | translate }}</h3>
            <div class="p-fluid formgrid grid">
              <div class="field col-4">
                <label style="font-weight: bolder;">{{'ForwarderPage.ForwarderUserOriginReview.OperationDocumentsTitle' | translate }} *</label>
                <p-dropdown [options]="operationDocumentTypes" placeholder="{{ 'ForwarderPage.ForwarderUserOriginReview.OperationDocumentsTitle' | translate}}" (onChange)="onSelectDocumentType($event)" styleClass="mb-2" optionLabel="description" optionValue="id" [disabled]="loading"></p-dropdown>
              </div>
              <div class="field col-12">
                <p-fileUpload #fileUpload
                    (onSelect)="onUploadDocumentPdf(fileUpload)"
                    [showUploadButton]="false"
                    [multiple]="false"
                    accept=".pdf,.xls,.xlsx"
                    [maxFileSize]="5000000"
                    [disabled]="documentTypeId === '' || loading"
                    chooseLabel="{{'OrderDetailTabComponent.Form.SelectFile' | translate}}"
                    cancelLabel="{{'OrderDetailTabComponent.Form.CancelSelectFile' | translate}}">
                </p-fileUpload>
              </div>
              <div class="field col-12">
                <p-table
                    [value]="documents"
                    responsiveLayout="stack"
                    [breakpoint]="'600px'">
                    <ng-template pTemplate="header">
                      <tr>
                        <th><div class="flex justify-content-center align-items-center">{{ 'ForwarderPage.ForwarderUserOriginReview.TableDocuments.DocumentName' | translate }}</div></th>
                        <th><div class="flex justify-content-center align-items-center">{{ 'ForwarderPage.ForwarderUserOriginReview.TableDocuments.OperationDocumentsTitle' | translate }}</div></th>
                        <th><div class="flex justify-content-center align-items-center">{{ 'ForwarderPage.ForwarderUserOriginReview.TableDocuments.DocumentSize' | translate }}</div></th>
                        <th><div class="flex justify-content-center align-items-center">{{ 'ForwarderPage.ForwarderUserOriginReview.TableDocuments.DocumentUser' | translate }}</div></th>
                        <th><div class="flex justify-content-center align-items-center">{{ 'ForwarderPage.ForwarderUserOriginReview.TableDocuments.CreatedDate' | translate }}</div></th>
                        <th><div class="flex justify-content-center align-items-center">{{ 'ForwarderPage.ForwarderUserOriginReview.TableDocuments.ActionsHeader' | translate }}</div></th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-document>
                        <tr>
                            <td style="cursor: pointer; color: #6E9F41" (click)="getImportOrderDetailDocument(document)"><div class="flex justify-content-start"><span class="pi pi-file"></span>{{ document.name }}</div></td>
                            <td><div class="flex justify-content-center">{{ document.operationDocumentType | documentDescription }}</div></td>
                            <td><div class="flex justify-content-center">{{ document.docLength / 1000 }} KB</div></td>
                            <td><div class="flex justify-content-center"><span class="pi pi-user"></span>{{ document.createdBy }}</div></td>
                            <td><div class="flex justify-content-end">{{ document.created | date:'dd-MM-yyyy HH:mm' }}</div></td>
                            <td><div class="flex justify-content-end"><p-button label="{{ 'ForwarderPage.ForwarderUserOriginReview.ButtonDelete' | translate }}" icon="pi pi-trash" styleClass="p-button-danger" (onClick)="deleteDocument(document)" [disabled]="loading"></p-button></div></td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="summary">
                        <div class="flex align-items-center justify-content-between" *ngIf="documents.length === 0">
                            {{ 'DocumentComponent.EmptyResult' | translate }}
                        </div>
                    </ng-template>
                </p-table>
              </div>
            </div>
        </div>

      </p-card>
    </div>
</app-user-dashboard>


<p-confirmDialog [style]="{width: '30vw'}"></p-confirmDialog>

<p-dialog header="{{ 'ChatNotification.Title' | translate }}" [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleMessageDialog" [style]="{width: '50%'}" [modal]="true">
  <app-user-import-order-chat [messages]="messages" [loading]="loadingMessages" (messageSent)="onMessageSent($event)"/>
</p-dialog>

